export enum AgioPaymentsModels {
    installment ='installment',
    onetime = 'onetime'
}